import { useMemo } from 'react';
import useInterveneTheme from './useInterveneTheme';

export default function useMessageFeedStyles() {
  const { chat } = useInterveneTheme();
  const feedBackground = chat.message?.feed?.background || chat.background;

  return useMemo(
    () => ({
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      px: { xs: 0.5, sm: 1 },
      py: { xs: 1.5, sm: 2 },
      display: 'flex',
      flexDirection: 'column',
      gap: 0.25,
      backgroundColor: feedBackground,
      '&::-webkit-scrollbar': { width: 6 },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: chat.divider,
        borderRadius: 999,
      },
    }),
    [chat.divider, feedBackground]
  );
}
